export const NAVIGATION_HEIGHT = 72;
